import './App.css';
import Banner from './components/Banner';
import Navbar from './components/Navbar';
import Skills from './components/Skills';
import ProjectsContainer from './containers/ProjectsContainer';
import Contact from './components/Contact';
import Experience from './components/Experience';
function App() {
  return (
    <>
      <Navbar />
      <Banner />
      <div className="wave-top1" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" className="wave-top2"><path d="M-0.00,49.98 C150.00,149.99 271.49,-49.98 500.00,49.98 L500.00,-0.00 L-0.00,-0.00 Z" className="wave-top3"></path></svg></div>
      <div className="wave-bottom1" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" className="wave-bottom2"><path d="M-0.00,49.98 C150.00,149.99 271.49,-49.98 500.00,49.98 L500.00,-0.00 L-0.00,-0.00 Z" className="wave-bottom3"></path></svg></div>
      <div className="row m-0" style={{ backgroundColor: '#090909', height: '100%' }}>
        <div className="col-12 col-lg-6 p-0 h-100">
          <Experience />
        </div>
        <div className="col-12 col-lg-6 p-0 h-100">
          <Skills />
        </div>
      </div>
      <ProjectsContainer />
      <Contact />
    </>
  );
}

export default App;
